import { DependencyList, useEffect } from "react";
import { useTimeoutFn } from "@/shared/hooks/debounce/use-timeout-function";
export type UseDebounceReturn = [() => boolean | null, () => void];

export const useDebounce = (
  fn: (...args: unknown[]) => unknown,
  ms = 0,
  deps: DependencyList = []
): UseDebounceReturn => {
  const [isReady, cancel, reset] = useTimeoutFn(fn, ms);

  useEffect(reset, [...deps, reset]);

  return [isReady, cancel];
};
